import React from 'react';
import { SiteShell, PageHead, H1, P, INK, SUB, LINE, CARD } from '../site/shell';

const wrap = { maxWidth:780, margin:'0 auto' };
const sec  = { padding:'clamp(10px,3vw,24px) clamp(20px,5vw,48px) clamp(70px,9vw,100px)' };

function Sec({ n, title, children }) {
  return (
    <div className="reveal" style={{ marginBottom:30 }}>
      <h2 style={{ ...H1,fontSize:19,color:INK,marginBottom:10 }}>{n ? `${n}. ` : ''}{title}</h2>
      <div style={{ fontSize:15,color:SUB,fontWeight:500,lineHeight:1.8 }}>{children}</div>
    </div>
  );
}
const a = { color:P, textDecoration:'none', fontWeight:600 };

function Legal({ title, accent, updated, children }) {
  return (
    <SiteShell title={`${title} ${accent}`.trim()} desc="CywerStudio legal information.">
      <PageHead tag="Legal" title={title} accent={accent} lead={updated} />
      <section style={sec}><div style={wrap}>{children}</div></section>
    </SiteShell>
  );
}

/* ── PRIVACY ──────────────────────────────────────────────────────── */
export function PrivacyPage() {
  return (
    <Legal title="Privacy" accent="Policy" updated="Last updated: September 2026">
      <Sec n="1" title="Introduction"><p>CywerStudio ("we") respects your privacy and processes your personal data in accordance with the General Data Protection Regulation (GDPR).</p></Sec>
      <Sec n="2" title="Data we collect"><p>This site is informational. We only collect the data you send us by email through the contact and brief forms (name, email and your message), plus anonymised usage analytics and technical data such as IP address and browser type.</p></Sec>
      <Sec n="3" title="How we use data"><p>We use your data only to reply to you and improve the site. We do not sell your data to third parties. Product purchases happen on the external stores (Unity Asset Store, SpigotMC, BuiltByBit), subject to those platforms' privacy policies.</p></Sec>
      <Sec n="4" title="Retention"><p>We keep the emails you send us for as long as they're needed for follow-up. You can request deletion at any time at <a href="mailto:privacy@cywerstudio.com" style={a}>privacy@cywerstudio.com</a>.</p></Sec>
      <Sec n="5" title="Processors"><p>We use Cloudflare (CDN/security), in compliance with the GDPR. We do not use advertising networks or data brokers.</p></Sec>
      <Sec n="6" title="Your rights"><p>Under the GDPR you have the right to access, rectify, erase and port your data. Contact <a href="mailto:privacy@cywerstudio.com" style={a}>privacy@cywerstudio.com</a>.</p></Sec>
    </Legal>
  );
}

/* ── TERMS ────────────────────────────────────────────────────────── */
export function TermsPage() {
  return (
    <Legal title="Terms of" accent="Use" updated="Last updated: September 2026">
      <Sec n="1" title="Acceptance"><p>By using this site or engaging a CywerStudio service, you accept these Terms. If you don't agree, don't use the service.</p></Sec>
      <Sec n="2" title="Our products"><p>We build tools for Unity and plugins for Minecraft, sold through external stores (Unity Asset Store, SpigotMC, BuiltByBit), and we provide custom development services. Purchases on the stores are also governed by those platforms' terms.</p></Sec>
      <Sec n="3" title="Acceptable use"><p>You may not use our products for illegal purposes, attempt to access our systems without authorisation, or resell or reuse them to create competing products.</p></Sec>
      <Sec n="4" title="Intellectual property"><p>The CywerStudio brand, products and code are ours. Buying a tool grants a license to use it, not ownership of the code.</p></Sec>
      <Sec n="5" title="Limitation of liability"><p>Products and services are provided "as is". Our total liability is limited to the amount paid for the product or service in question.</p></Sec>
      <Sec n="6" title="Governing law"><p>These terms are governed by Portuguese law. Disputes are subject to the courts of Portugal.</p></Sec>
    </Legal>
  );
}

/* ── REFUNDS ──────────────────────────────────────────────────────── */
export function RefundPage() {
  return (
    <Legal title="Refund" accent="Policy" updated="Last updated: September 2026">
      <Sec n="1" title="Purchases on external stores"><p>The tools are sold on the Unity Asset Store, SpigotMC and BuiltByBit. Refunds for those purchases follow the refund policy of the respective platform.</p></Sec>
      <Sec n="2" title="Faulty products"><p>If a product is faulty or significantly different from described, contact us — we'll help resolve it or route the refund with the store.</p></Sec>
      <Sec n="3" title="Custom services"><p>Custom projects are governed by the proposal agreed before work starts. Payment and cancellation terms are set out in that proposal.</p></Sec>
      <Sec n="4" title="Contact"><p>Write to <a href="mailto:support@cywerstudio.com" style={a}>support@cywerstudio.com</a> with the details. We usually reply within 24h.</p></Sec>
    </Legal>
  );
}

/* ── COOKIES ──────────────────────────────────────────────────────── */
export function CookiesPage() {
  const COOKIES = [
    { name:'Preferences', type:'Functional', desc:'Stores small display preferences in your browser.' },
    { name:'Anonymised analytics', type:'Analytics', desc:'Helps us understand which pages bring visitors. No identifiable personal data.' },
  ];
  return (
    <Legal title="Cookie" accent="Policy" updated="Last updated: September 2026">
      <Sec n="1" title="What are cookies?"><p>Cookies are small files stored on your device. We use them only where necessary to operate the site.</p></Sec>
      <Sec n="2" title="Cookies we use">
        <div style={{ display:'flex',flexDirection:'column',gap:12,marginTop:10 }}>
          {COOKIES.map(c => (
            <div key={c.name} style={{ background:CARD,border:`1px solid ${LINE}`,borderRadius:12,padding:'14px 16px' }}>
              <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',gap:8,marginBottom:5 }}>
                <p style={{ ...H1,fontSize:14,color:INK }}>{c.name}</p>
                <span style={{ fontSize:10,fontWeight:700,color:P,background:'rgba(163,102,255,.12)',border:`1px solid ${LINE}`,padding:'3px 9px',borderRadius:999,textTransform:'uppercase',letterSpacing:'.06em' }}>{c.type}</span>
              </div>
              <p style={{ fontSize:14,color:SUB,fontWeight:500,lineHeight:1.6 }}>{c.desc}</p>
            </div>
          ))}
        </div>
      </Sec>
      <Sec n="3" title="Contact"><p><a href="mailto:privacy@cywerstudio.com" style={a}>privacy@cywerstudio.com</a></p></Sec>
    </Legal>
  );
}
